import React, { useEffect, useState } from "react";
import Linkify from "react-linkify";

const ExerciseItem = ({ hw }) => {
  const [yt, setYt] = useState(null);
  useEffect(() => {
    if (hw.ytLink) {
      const str = hw.ytLink;
      const ytString = str.replace(
        "https://www.youtube.com/watch?v=",
        "https://www.youtube.com/embed/"
      );
      setYt(ytString);
    }
  }, []);

  return (
    <div>
      <section className='work-container'>
        <div className='work-general'>
          <div className='work-title'>
            <h1>{hw.lessonTitle} </h1>
          </div>

          <div className='work-instructions-vaje'>
            <div className='work-vaje'>
              <h1>Opis vaje</h1>
              <p>{hw.lessonInstructionsOne}</p>
            </div>
            <div className='work-vaje'>
              <h1>Povezave</h1>
              <h3>
                {hw.lessonLinkOne && "1."} {hw.lessonLinkOneInfo}
              </h3>
              <a href={hw.lessonLinkOne} target='_blank'>
                {hw.lessonLinkOne}
              </a>
              <h3>
                {hw.lessonLinkTwo && "2."} {hw.lessonLinkTwoInfo}
              </h3>
              <a href={hw.lessonLinkTwo} target='_blank'>
                {hw.lessonLinkTwo}
              </a>
              <h3>
                {hw.lessonLinkThree && "3."} {hw.lessonLinkThreeInfo}
              </h3>
              <a href={hw.lessonLinkThree} target='_blank'>
                {hw.lessonLinkThree}
              </a>
              <h3>
                {hw.lessonLinkFour && "4."} {hw.lessonLinkFourInfo}
              </h3>
              <a href={hw.lessonLinkFour} target='_blank'>
                {hw.lessonLinkFour}
              </a>
            </div>
          </div>
        </div>
        {hw.ytLink || hw.ytLinkInfo ? (
          <div className='work-section'>
            <div className='work-section-title'>
              <h1>Video</h1>
            </div>
            <div className='work-section-instructions'>
              <h1>{hw.ytLinkInfo}</h1>
              <p>
                Če video ne dela, uporabi povezavo:{" "}
                <a
                  href={hw.ytLink}
                  target='_blank'
                  style={{ color: "blue", fontSize: "1.6rem" }}
                >
                  VIDEO
                </a>
              </p>
            </div>
            <div className='work-google'>
              <iframe
                width='560'
                height='315'
                src={yt}
                frameborder='0'
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                allowfullscreen
              ></iframe>
            </div>
          </div>
        ) : (
          false
        )}
        {hw.lessonPartOneSrc ? (
          <div className='work-section'>
            <div className='work-section-title'>
              <h1>Vaja</h1>
            </div>
            <div className='work-section-instructions'>
              <h1>{hw.lessonPartOneInstructions}</h1>
            </div>
            <div className='work-google-vaje'>
              <iframe
                src={hw.lessonPartOneSrc}
                frameborder='0'
                width='1920'
                height='560'
                allowfullscreen='true'
                mozallowfullscreen='true'
                webkitallowfullscreen='true'
              ></iframe>
            </div>
          </div>
        ) : (
          false
        )}

        {hw.lessonPartTwoSrc ? (
          <div className='work-section'>
            <div className='work-section-title'>
              <h1>2. sklop</h1>
            </div>
            <div className='work-section-instructions'>
              <h1>{hw.lessonPartTwoInstructions}</h1>
            </div>
            <div className='work-google'>
              <iframe
                src={hw.lessonPartTwoSrc}
                width='1080'
                height='1050'
                frameborder='0'
                marginheight='0'
                marginwidth='0'
              ></iframe>
            </div>
          </div>
        ) : (
          false
        )}
        {hw.lessonPartThreeSrc ? (
          <div className='work-section'>
            <div className='work-section-title'>
              <h1>2. sklop</h1>
            </div>
            <div className='work-section-instructions'>
              <h1>{hw.lessonPartThreeInstructions}</h1>
            </div>
            <div className='work-google'>
              <iframe
                src={hw.lessonPartThreeSrc}
                width='1600'
                height='1050'
                frameborder='0'
                marginheight='0'
                marginwidth='0'
              ></iframe>
            </div>
          </div>
        ) : (
          false
        )}
        {hw.lessonPartFourSrc ? (
          <div className='work-section'>
            <div className='work-section-title'>
              <h1>2. sklop</h1>
            </div>
            <div className='work-section-instructions'>
              <h1>{hw.lessonPartFourInstructions}</h1>
            </div>
            <div className='work-google'>
              <iframe src={hw.lessongPartFourSrc}></iframe>
            </div>
          </div>
        ) : (
          false
        )}
      </section>
      <button className='work-button'>NAZAJ NA VRH</button>
    </div>
  );
};

export default ExerciseItem;
